import type { AppVersion, DeviceInfoPayload } from '@muzly/shared';

import type { TFunction } from 'i18next';

/** 문의 받는 주소 — 문의 문서 본문(`web.more.docs.contact.body`)의 주소와 같아야 한다. */
export const SUPPORT_EMAIL = 'support@muzly.io';

/**
 * 네이티브 `getDeviceInfo` 의 `osVersion` 은 `Platform.Version` 이라 Android 에서는 OS 버전이 아니라
 * API 레벨(예: 34)이다 — 그렇게 적는다. `model`·`appVersion` 은 셸이 고정값을 돌려줘서
 * (`apps/mobile/src/utils/deviceInfo.ts`) 본문에 싣지 않는다. 앱 버전은 `getAppVersion` 이 정본이다.
 */
const osLine = ({
  platform,
  osVersion,
}: Pick<DeviceInfoPayload, 'platform' | 'osVersion'>): string =>
  platform === 'ios' ? `iOS ${osVersion}` : `Android API ${osVersion}`;

/**
 * 문의 메일 `mailto:` — 제목과 본문 끝 앱 정보를 미리 채운다. 답장하는 쪽이 어느 버전·기기의
 * 문제인지 되묻지 않게 한다. `app`·`device` 는 앱 안에서만 있다(브리지).
 *
 * 인코딩은 `encodeURIComponent` 다 — `URLSearchParams` 는 공백을 `+` 로 쓰는데, `mailto:` 는
 * 폼 인코딩이 아니라 `+` 가 공백으로 읽힐 보장이 없다.
 */
export const contactMailUrl = (
  t: TFunction,
  {
    web,
    app,
    device,
  }: { web: string; app?: AppVersion; device?: DeviceInfoPayload },
): string => {
  const lines = [
    '',
    '',
    '',
    '----',
    t('web.more.contactMail.info'),
    // MY 의 앱 버전 줄과 같은 값이다(웹에서는 화면이 `v` 없이 숫자만 적는다 — 시안 표기).
    `${t('web.more.version')}: ${
      app
        ? t('web.more.versionNative', {
            app: app.version,
            build: app.buildNumber,
            web,
          })
        : t('web.more.versionWeb', { web })
    }`,
  ];
  if (device) {
    lines.push(t('web.more.contactMail.os', { os: osLine(device) }));
  }
  const subject = encodeURIComponent(t('web.more.contactMail.subject'));
  const body = encodeURIComponent(lines.join('\n'));
  return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
};
